// operatingSystem.js
export const OPERATING_SYSTEMS = {
  oculusQuest: {key:"oculusQuest",value:"Oculus Quest"},
  androidXR: {key:"androidXR",value:"Android XR"},
  visionOS: {key:"appleVisionPro",value:"Apple Vision PRO"},
};